import React from 'react'

const ShareIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    {...props}
  >
    <path
      d='M3.4987 13.4167C3.17786 13.4167 2.90321 13.3024 2.67474 13.074C2.44627 12.8455 2.33203 12.5708 2.33203 12.25V5.83334C2.33203 5.5125 2.44627 5.23785 2.67474 5.00938C2.90321 4.78091 3.17786 4.66667 3.4987 4.66667H5.2487V5.83334H3.4987V12.25H10.4987V5.83334H8.7487V4.66667H10.4987C10.8195 4.66667 11.0942 4.78091 11.3227 5.00938C11.5511 5.23785 11.6654 5.5125 11.6654 5.83334V12.25C11.6654 12.5708 11.5511 12.8455 11.3227 13.074C11.0942 13.3024 10.8195 13.4167 10.4987 13.4167H3.4987ZM6.41536 9.33334V2.81459L5.48203 3.74792L4.66536 2.91667L6.9987 0.583336L9.33203 2.91667L8.51536 3.74792L7.58203 2.81459V9.33334H6.41536Z'
      fill='currentcolor'
    />
  </svg>
)

export default ShareIcon
